// Engine/server lockstep rollout guard (engine v10).
//
// Every call to a lockstep-sensitive endpoint (MP rooms, MP deck, WhatsApp deck
// sync) carries this client's ENGINE_VERSION in X-Nomadmon-Engine. A server on
// a different engine answers 426 { code: 'UPDATE_REQUIRED' }. The client then
// drops its service worker + caches and reloads once, so a stale cached build
// can never play (or submit a deck) under rules it does not run. One forced
// reload per two minutes, so a server/client mismatch cannot loop.
import { ENGINE_VERSION } from './engine.js';

export const ENGINE_HEADER = 'X-Nomadmon-Engine';
export const engineHeaders = () => ({ [ENGINE_HEADER]: String(ENGINE_VERSION) });
const KEY = 'nomadmon-forced-update';

export function isUpdateRequired(status, body) {
  return status === 426 || (body && body.code === 'UPDATE_REQUIRED');
}

export async function forceUpdate() {
  try {
    const last = +(sessionStorage.getItem(KEY) || 0);
    if (Date.now() - last < 120000) return false;      // already tried: let the error show
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch { /* private mode: still try once */ }
  try {
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map(r => r.unregister().catch(() => {})));
    }
    if (typeof caches !== 'undefined') {
      const keys = await caches.keys();
      await Promise.all(keys.map(k => caches.delete(k).catch(() => {})));
    }
  } catch { /* best effort */ }
  location.reload();
  return true;
}
